import "./nav.css";
import { getPath, Link } from "../router";

export default function Nav() {
  // Nav remounts with each page chunk, so the path at mount is the active
  // route - the underline animates in on every page swap.
  const path = getPath();
  const linkClass = (href: string) =>
    path === href ? "nav-link nav-link--active" : "nav-link";
  return (
    <header className="nav">
      <div className="nav-inner">
        <Link className="nav-brand" href="/" aria-label="JetShake home">
          <img
            className="nav-mark"
            src="/jetshake-mark.svg"
            alt=""
            width={28}
            height={28}
          />
          <span className="nav-wordmark">JetShake</span>
        </Link>
        <nav className="nav-links">
          <Link className={linkClass("/how-it-works")} href="/how-it-works">
            How it works
          </Link>
          <Link className={linkClass("/philosophy")} href="/philosophy">
            Philosophy
          </Link>
        </nav>
      </div>
    </header>
  );
}
